export const tripMeta = (itinerary = {}) => {
  const { regions = [], countries = [] } = itinerary;
  const locations = regions.slice();
  return {
    regions,
    countries,
    locations,
  };
};
